/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import { getAllDeptos } from '../../services/ApiCalls';

const Departments = (props) => {
  const { handleClick } = props;
  const [menus, setMenus] = useState([]);

  useEffect(() => {
    async function apiCall() {
      const response = await getAllDeptos();
      setMenus(response);
    }
    apiCall();
  }, []);

  return (
    <ul className="nav-list">
      { menus.map((department, index) => (
        <li key={index} onClick={() => handleClick(department)} className="departments">
          { department.depto }
          <ArrowForwardIosIcon className="next-icon" fontSize="small" />
        </li>
      ))}
    </ul>
  );
};

Departments.propTypes = {
  // eslint-disable-next-line react/no-typos
  handleClick: PropTypes.function,
  setChangeId: PropTypes.string,
}.isRequired;

export default Departments;
